import { useState, useEffect } from 'react'

import './online.css'

const Online = ({id, infor, avatar}) => {

      const [online, setOnline] = useState([])

      async function getOnline(id_xat){
            try{
                  const response = await fetch(`https://oceanbot.net/online.php?id=${id_xat}`)
                  const result = await response.json()
                  setOnline(result)
            }
            catch(err){
                  console.log('Erro: ', err)
            }
      }

      useEffect(() => {
            getOnline(id)
      }, [id])

      return (
            <div className="wrapper_online">
                  <div className="online_avatar">
                        <img src={infor.avatar === '' ? avatar : infor.avatar} alt="Avatar" />
                        <div className={online.status === 'online' ? "online_dots green" : "online_dots red"}></div>
                  </div>
                  <span>{online.status === 'online' ? "Online Now" : "Offline"}</span>
            </div>
      )
}

export default Online
